import Heading from "Components/Heading";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Form } from "react-bootstrap";
import Footer from "Components/Footer";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate } from "react-router";
import AuthAPIs from "../../APIs/auth";
import Loader from "Components/Loader";
import SampleDataTable from "Components/DataTables";
import { Link } from "react-router-dom";
import { formatDate } from "Helper/Converters";

const ManageUser = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  //  Global search state
  const [searchText, setSearchText] = useState("");

  const navigation = useNavigate();

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    setIsLoading(true);
    const usersRes = await AuthAPIs.getAllUsers();
    if (usersRes) {
      setUsers(
        usersRes.data.data?.sort((a, b) => {
          const A = (a.label || "").toLowerCase();
          const B = (b.label || "").toLowerCase();
          if (A < B) return -1;
          if (A > B) return 1;
          return 0;
        }),
      );
    }
    setIsLoading(false);
  };

  const ciSort = (rowA, rowB, columnId) => {
    const a = String(rowA.values[columnId] ?? "")
      .trim()
      .toLowerCase();
    const b = String(rowB.values[columnId] ?? "")
      .trim()
      .toLowerCase();
    return a.localeCompare(b);
  };

  const columns = [
    {
      accessor: "username",
      Header: "Username",
      sortType: ciSort
    },
    { accessor: "email", Header: "Email", sortType: ciSort },
    // {
    //   accessor: "department",
    //   Header: "Department",
    //   Cell: ({ row }) => <p>{row?.original?.department?.name}</p>,
    // },
    {
      id: "departmentName", // required because accessor is a function
      Header: "Department",
      accessor: (row) => row?.department?.name || "", // sortable string
      Cell: ({ row }) => <p>{row?.original?.department?.name}</p>,
      sortType: ciSort
    },
    { accessor: "city", Header: "City", sortType: ciSort },
    { accessor: "phoneNumber", Header: "Phone No.", sortType: ciSort },

    // REMOVED:
    // { accessor: "emergencyPhoneNumber", Header: "Emergency Phone Number" },

    //  REMOVED:
    // {
    //   accessor: "dob",
    //   Header: "DOB",
    //   Cell: ({ row }) => (
    //     <p>{row?.original?.dob ? formatDate(row.original.dob) : ""}</p>
    //   ),
    // },

    // {
    //   accessor: "isActive",
    //   Header: "Status",
    //   Cell: ({ row }) => (
    //     <span
    //       style={{
    //         color: row?.original?.isActive ? "#28a745" : "#dc3545",
    //         fontWeight: "bold",
    //       }}
    //     >
    //       {row?.original?.isActive ? "Active" : "Inactive"}
    //     </span>
    //   ),
    // },
    {
      id: "statusText", //  required because accessor is a function
      Header: "Status",
      accessor: (row) => (row?.isActive ? "Active" : "Inactive"), // sortable string
      Cell: ({ row }) => (
        <span
          style={{
            color: row?.original?.isActive ? "#28a745" : "#dc3545",
            fontWeight: "bold",
          }}
        >
          {row?.original?.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      accessor: "id",
      Header: "Action",
      Cell: ({ row }) => (
        <Link
          className="link"
          to={`/dashboard/user-setup/edit/${row.original.id}`}
          rel="noopener noreferrer"
        >
          Edit
        </Link>
      ),
    },
  ];

  const filteredUsers = useMemo(() => {
    const q = searchText.trim().toLowerCase();
    if (!q) return users;

    //  Special handling for status to avoid "active" matching "inactive"
    const statusQuery = q === "active" || q === "inactive" ? q : null;

    return users.filter((u) => {
      //  Status exact match (not substring)
      const statusText = u?.isActive ? "active" : "inactive";
      if (statusQuery) return statusText === statusQuery;

      const departmentName = u?.department?.name || "";

      //  Updated haystack: removed emergencyPhoneNumber + dob
      const haystack = [
        u?.username,
        u?.email,
        departmentName,
        u?.city,
        u?.phoneNumber,
        statusText,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return haystack.includes(q);
    });
  }, [users, searchText]);

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <section>
        <Heading text={"Manage User"} />
        <Card>
          {/* Top bar: Search + Add button */}
          <Col
            className="column"
            style={{
              maxWidth: "100%",
              marginTop: "28px",
              paddingBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              gap: "12px",
              alignItems: "center",
            }}
          >
            <Form.Control
              type="text"
              placeholder="Search by username, email, department, city, status..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ maxWidth: "420px" }}
            />

            <Button onClick={() => navigation("/dashboard/user-setup/add")}>
              <AiOutlinePlus />
              Add
            </Button>
          </Col>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%", maxWidth: 1250 }}>
              <SampleDataTable
                columns={columns}
                data={filteredUsers}
                noDataMsg={"No Users Available"}
              />
            </div>
          </div>
          <Footer />
        </Card>
      </section>
    </>
  );
};

export default ManageUser;